export * from './IconSmileFilled';
